import { default as Commitments } from "./Commitments/lang.en";
import { default as Stream } from "./Stream/lang.en";
import { default as WorkStyles } from "./WorkStyles/lang.en";
import { default as oneTimeMeetingForm } from "./Stream/forms/oneTimeMeetingForm.en";
import { default as recurrenceForm } from "./Stream/forms/recurrenceForm.en";
import { default as templateForm } from "./Stream/forms/templateForm.en";

export default {
	Commitments,
	Stream,
	WorkStyles,
	oneTimeMeetingForm,
	recurrenceForm,
	templateForm,
};
